module.exports = __webpack_public_path__ + "static/image10@2x-ab362c10ecdb2ad8a154693b33fcb6f3.png";